import { Injectable } from '@angular/core';
import { CommitmentSearchRequestModel } from '@alcon-db-models/CommitmentSearchRequestModel';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { SearchServiceBase } from './search-service-base';
import { AppUxService } from './app-ux.service';

@Injectable({
  providedIn: 'root'
})
export class CommitmentSearchService extends SearchServiceBase<CommitmentSearchRequestModel> {
  constructor(protected http: HttpClient, protected router: Router, protected store: Store, appUxService: AppUxService) {
    super(http, router, store, 'CommitmentSearch', appUxService);
  }
}
